








import { InstanceResolver } from '@/util/instanceResolver'
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Component
export default class CartSignUpDefaultAttention extends Vue {
  @Prop({ required: true })
  hostName: string

  get rule(): string {
    return `${this.prefix}/rule`
  }
  get privacy(): string {
    return `${this.prefix}/privacy`
  }

  private get prefix(): string {
    return InstanceResolver.isSingle() ?
      '' :
      '/mycolor'
  }
}
